import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21382d6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "refinanca-banner__content" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"refinanca-banner__icon\" data-v-21382d6d><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#213f80\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-21382d6d><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-21382d6d></circle><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"12\" data-v-21382d6d></line><line x1=\"12\" y1=\"16\" x2=\"12.01\" y2=\"16\" data-v-21382d6d></line></svg></div><p class=\"refinanca-banner__text\" data-v-21382d6d><strong data-v-21382d6d>Estimado cliente:</strong> Le informamos que si su obligación era administrada por <strong data-v-21382d6d>Refinancia</strong> ahora será administrada por <strong data-v-21382d6d>Teranova Labs SAS (Tranqui)</strong> a partir del <strong data-v-21382d6d>1 de marzo</strong> del año en curso. </p>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isBannerVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "refinanca-banner",
        style: _normalizeStyle({ bottom: _ctx.bannerBottom + 'px' })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("button", {
            class: "refinanca-banner__close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeBanner && _ctx.closeBanner(...args)))
          }, " ✕ ")
        ])
      ], 4))
    : _createCommentVNode("", true)
}